module.exports = __webpack_public_path__ + "img/hr-pump-north-liquid.461f419b.png";